import { useState } from "react";
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogCancel } from "@/components/ui/alert-dialog";

export function RemoveUserDialog({ user, onCancel, onConfirm }) {
  const [typed, setTyped] = useState("");
  const [busy, setBusy] = useState(false);
  const ok = user && typed.trim().toLowerCase() === user.email.toLowerCase();
  const close = () => { setTyped(""); onCancel(); };
  const go = async () => { setBusy(true); await onConfirm(user); setBusy(false); setTyped(""); };
  return (
    <AlertDialog open={!!user} onOpenChange={(o) => !o && close()}>
      <AlertDialogContent data-testid="remove-user-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Remove {user?.name}?</AlertDialogTitle>
          <AlertDialogDescription>This permanently deletes their account, Airbnbs, guest pages, guests, check-ins, orders, invoices and housekeeping reports. It can't be undone.</AlertDialogDescription>
        </AlertDialogHeader>
        <label className="text-sm">Type <b>{user?.email}</b> to confirm
          <input value={typed} onChange={(e) => setTyped(e.target.value)} autoFocus data-testid="remove-user-confirm-input" className="mt-1.5 h-10 w-full rounded-lg border border-input px-3 text-sm outline-none focus:ring-2 focus:ring-[#D96C4A]" />
        </label>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={close} data-testid="remove-user-cancel">Cancel</AlertDialogCancel>
          <button onClick={go} disabled={!ok || busy} data-testid="remove-user-confirm-button" className="inline-flex h-10 items-center justify-center rounded-md bg-[#B3261E] px-4 text-sm font-semibold text-white disabled:opacity-40">Remove user</button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
